import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { MeetingPage } from '@/features/meetings/pages/meeting-page';

// The conversation of a call's channel, in the room's side panel: the chat feature is loaded when
// the panel opens (the meetings feature never imports the chat one).
const ConversationView = lazy(() =>
  import('@/features/chat/conversation-view').then((m) => ({ default: m.ConversationView })),
);

/**
 * The room of a meeting or a call (full screen, outside the shell: see AppLayout). Pre-join, then
 * the room; LiveKit is loaded when the person presses "Rejoindre".
 */
export const Route = createFileRoute('/_auth/o/$orgId/meetings/$meetingId')({
  component: MeetingRoute,
});

function MeetingRoute() {
  const { orgId, meetingId } = Route.useParams();
  return (
    <MeetingPage
      orgId={orgId}
      meetingId={meetingId}
      renderChat={(channelId) => (
        <Suspense fallback={null}>
          <ConversationView orgId={orgId} channelId={channelId} embedded />
        </Suspense>
      )}
    />
  );
}
